module.exports = __webpack_public_path__ + "img/cnt1-m.60fba405.jpg";